import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import { Grid } from "@material-ui/core";
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from "react-router-dom";
import { hgStripe } from "../StripeConfig.js";
import ConfirmationModal from "../../../components/modal/ConfirmationModal";
import MembershipPlanCard from "./MembershipPlanCard";
import MembershipFAQ from "./MembershipFAQ";
import HgSuperPayAddonSection from "./HgSuperPayAddonSection";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import StarIcon from "@material-ui/icons/Star";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import "../MembershipPage.css";

const styles = theme => ({
    card: {
      maxWidth: 400,
    },
    media: {
      height: 0,
      paddingTop: '56.25%',
    },
    actions: {
      display: 'flex',
    },
    expand: {
      transform: 'rotate(0deg)',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
      }),
      marginLeft: 'auto',
      [theme.breakpoints.up('sm')]: {
        marginRight: -8,
      },
    },
    expandOpen: {
      transform: 'rotate(180deg)',
    },
    button: {
        margin: theme.spacing.unit,
      },
  });

@inject("userStore", "profileStore", "hgBillingStore")
@withRouter
@observer
class EntertainerBilling extends Component {
    constructor(props) {
        super(props);
    }

    state = {
        toggleModal: false
    };

    selectPlan = (value, type, isReturn) => {
        if (isReturn) return;
        this.props.selectPlan(value, type);
    }

    selecFreePlan = () => {
        this.props.selecFreePlan();
    }

    handleOpenModal = (isReturn) => {
        if (isReturn) return;
        this.setState({ toggleModal: true });
    }

    handleCloseModal = () => {
        this.setState({
            ...this.state,
            toggleModal: false
        });
    };

    render() {
        const { billingAccess } = this.props.hgBillingStore;

        var isMusicianFree = !billingAccess ? true : false || billingAccess.isFreePlan || billingAccess?.priceId === hgStripe.pricing.entertainerMembershipFree;
        var isMusicianPro = billingAccess?.priceId === hgStripe.pricing.entertainerMembershipPro;
        var isMusicianProPlus = billingAccess?.priceId === hgStripe.pricing.entertainerProPlusMembership;
        var priceIdExisted = billingAccess?.priceId ? true : false;
        var isEssential = billingAccess?.isBasicPlan && !priceIdExisted;
        var isProPlan = billingAccess?.isProPlan && !priceIdExisted;

        const freeFeatures = [
            "Create & manage your personal profile",
            "Unlimited act profiles",
            "Manage act lineup players",
            "Be discovered by venues, agents and private hirers",
            "Apply to Play (Venues & Agents)",
            "Up to 4 private booking invoices per month",
            "Automated Invoicing",
            "Social post management for live events and general posts"
        ];

        const proFeatures = [
            "Everything in Free plus:",
            "Up to 8 private booking invoices per month",
            "Pro label on your public profile",
            "Accounting Package Integrations including XERO & MYOB (Quickbooks coming soon)"
        ];

        const proPlusFeatures = [
            "Everything in Pro plus:",
            "Unlimited private booking invoices"
        ];

        const entertainerFAQs = [
            {
                question: "Can I change my plan at any time?",
                answer: "Yes, you can upgrade or downgrade your plan at any time. Changes will take effect immediately, and we'll prorate any billing adjustments."
            },
            {
                question: "What happens to my data if I downgrade?",
                answer: "Your data is always safe. If you downgrade, you'll retain access to all your historical data, but some premium features may become unavailable."
            },
            {
                question: "How does monthly billing work?",
                answer: "Your subscription renews automatically each month. You can cancel anytime, and you'll retain access until the end of your billing period."
            },
            {
                question: "What are private booking invoices?",
                answer: "Private booking invoices are for gigs you book directly with clients outside of Hot Giggity. Each plan includes a different monthly limit for these invoices."
            }
        ];

        return (
            <Fragment>
                <div className="membership-container">
                    <Grid container spacing={24}>
                        <Grid item xs={12}>
                            <div className="membership-grid">
                                <MembershipPlanCard
                                    planType="free"
                                    planName="Free"
                                    tagline="Get started with the basics"
                                    icon={<PersonOutlineIcon />}
                                    features={freeFeatures}
                                    isCurrentMonthly={isMusicianFree}
                                    onSelectFree={() => this.handleOpenModal(isMusicianFree)}
                                    isFreePlan={true}
                                />

                                <MembershipPlanCard
                                    planType="essentials"
                                    planName="Pro"
                                    tagline="For growing entertainers"
                                    icon={<StarBorderIcon />}
                                    features={proFeatures}
                                    monthlyPrice={!isMusicianPro && isEssential ? "Free" : "$19"}
                                    monthlyLabel="Pay Monthly"
                                    isCurrentMonthly={isMusicianPro || isEssential}
                                    onSelectMonthly={() => this.selectPlan(hgStripe.pricing.entertainerMembershipPro, 1, isMusicianPro || isEssential)}
                                    singleMonthly={true}
                                />

                                <MembershipPlanCard
                                    planType="pro"
                                    planName="Pro Plus"
                                    tagline="For professional entertainers"
                                    icon={<StarIcon />}
                                    features={proPlusFeatures}
                                    monthlyPrice={!isMusicianProPlus && isProPlan ? "Free" : "$29"}
                                    monthlyLabel="Pay Monthly"
                                    isCurrentMonthly={isMusicianProPlus || isProPlan}
                                    onSelectMonthly={() => this.selectPlan(hgStripe.pricing.entertainerProPlusMembership, 1, isMusicianProPlus || isProPlan)}
                                    singleMonthly={true}
                                    highlighted={true}
                                />
                            </div>
                        </Grid>
                    </Grid>

                    <HgSuperPayAddonSection />
                    <MembershipFAQ faqItems={entertainerFAQs} />
                </div>

                <ConfirmationModal
                    open={this.state.toggleModal}
                    title={"Select Free Plan"}
                    message={`Are you sure you want to select the free plan?`}
                    closeHandler={this.handleOpenModal}
                    confirmationHandler={this.selecFreePlan}
                    declineHandler={this.handleCloseModal}
                    confirmationLabel="Confirm"
                />
            </Fragment>
        );
    }
}

export default withStyles(styles)(EntertainerBilling);
